import axios from "axios";
import router from "./router";
import { Loading, Message } from 'element-ui'; //项目已经全局引入element的话可以不单独引入
import api from "./api";

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中…',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.4)',
    customClass:'fontColor'
  });
}
function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

//请求初始化配置
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.baseURL = "/";

// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
      if (process.env.NODE_ENV === 'development') {
        console.log("=============== "+ config.url +" ===============")
        console.log("请求参数")
        console.log(config.data)
      }
      // 在发送请求之前做些什么
      if (config.method === "post") {
        if (sessionStorage.getItem("token") && config.url !== api.login && config.url !== '/api/upload/uploadTokenImg') {
          config.data.token = sessionStorage.getItem("token");
          let signature_ = signature(config.data, sessionStorage.getItem("keyid"))
          config.data.sign = signature_
        }
      } else if (config.method === "get") {
        if (sessionStorage.getItem("token")) {
          config.params.token = sessionStorage.getItem("token");
          let signature_ = signature(config.params, sessionStorage.getItem("keyid"))
          config.params.sign = signature_
        }        
      }
      if (config.url == api.shopconf_get_address || config.url == api.knowledge_sort_channel || config.url == api.sortSku || config.url == api.sortPrize) {
        console.log('111', config.url)
        console.log('111', api.knowledge_sort_channel)
      } else {
        showFullScreenLoading()
      }
      
      return config;
    },
    function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
      if (process.env.NODE_ENV === 'development') {
        console.log("请求结果") 
        console.log(response)
        console.log("========================================================================================")
        console.log(" ")
      }
      // 对响应数据做点什么
      if (response.data.errorCode == -100) {
      }
      if (response.config.url == api.shopconf_get_address || response.config.url == api.knowledge_sort_channel) {
      } else {
        tryHideFullScreenLoading()
      }
      if (response.config.url.indexOf(api.subscribe_config) == -1) {
        if (response.data.code === 2 || response.data.code === 3) {
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('keyid')
          router.replace({
            path: "/login",
            redirect: ""
          });
        }
      }
      // response.data.msg !== "未找到符合的模板标题"
      if (response.data.code > 0 && response.data.msg !== "未找到符合的模板标题") {
        if(response.config.url.indexOf('/filings/applyIcpFiling')!= -1){
          let msgText = ''
          let msgData = response.data.msg.hints
          if(msgData && msgData.length > 0){
            // msgData.forEach(item=>{
            //   msgText = msgText + item.errmsg + ';'
            // })
            Message.error('提交失败'); 
          }
          // console.log(msgText)
        }else{
          Message.error(response.data.msg); 
        }
      } 

      return response;
    },
    function (error) {
      // 对响应错误做点什么
      if (error.response) {
        switch (error.response.status) {
          case 500 :
            tryHideFullScreenLoading()
            // router.replace({
            //   path: "/",
            //   redirect: "/home"
            // });
        }
      }
      return Promise.reject(error);
    }
);

/**
 * 签名
 * @param data        提交的数据
 * @param key         安全密钥
 * @returns {string}
 */
export function signature(data, key) {
  let hexMD5 = require("./assets/js/md5.js").hexMD5;
  let n = null, d = {}, str = '', s = ''
  n = Object.keys(data).sort()
  for (let i in n) {
    d[n[i]] = data[n[i]]
  }
  for (let k in d) {
    if (d[k] === '') continue
    if (str != '') str += '&'
    str += k + '=' + encodeURI(d[k])
  }
  str = str.replace("%20", " ")
  str += '&key=' + key
  if (str.indexOf('%5B') !== -1 && str.indexOf('%5D') !== -1) {
    str = str.replace(/%5B/g,"[")
    str = str.replace(/%5D/g,"]")
  }
  s = hexMD5(hexMD5(str)).toUpperCase() // 这儿是进行MD5加密并转大写
  return s
}

export default axios;
